import { adminWorkspaceQueryKeys as e } from "./adminWorkspaceQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { workspaceAdminApi as r } from "@maat/api-main";
//#region src/workspaces/admin/useUpdateWorkspaceCommissionMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ id: e, commission_rate: t }) => r.updateCommission(e, { commission_rate: t }),
		onSuccess: (t, { id: n }) => {
			i.invalidateQueries({ queryKey: e.detail(n) }), i.invalidateQueries({ queryKey: ["admin-workspaces", "list"] });
		}
	});
};
//#endregion
export { i as useUpdateWorkspaceCommissionMutation };
